export default __webpack_public_path__ + "static/media/investmentone.2f8998bc.svg";